import { useMeta } from '@nuxtjs/composition-api';
import { useLocalization } from '~/composables/_next/useLocalization';

export default function useHtmlMeta() {
  const { locale, defaultLocale } = useLocalization();
  function setHtmlLocale() {
    useMeta({
      htmlAttrs: { lang: locale ?? defaultLocale },
    });
  }

  return { setHtmlLocale };
}
